import { STATS } from "@/data/site";

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative border-y border-white/5 bg-[#0A1128]/50 backdrop-blur-sm"
    >
      <div className="container-x py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-8">
          {STATS.map((s, i) => (
            <div
              data-testid={`stat-${i}`}
              key={s.label}
              className="text-center md:text-left md:border-l border-white/10 md:pl-8 first:border-l-0 first:pl-0"
            >
              <div className="font-serif text-5xl md:text-6xl font-light text-[#FFC857] leading-none">
                {s.value}
              </div>
              <div className="mt-4 text-xs md:text-sm uppercase tracking-[0.2em] text-[#A0ABC0]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
